










































import {
    computed,
    defineComponent,
    onMounted,
    ref,
} from '@nuxtjs/composition-api';

interface Post {
  title: string;
  date: string;
  content: string;
  slug: string;
  author: string;
  tags: string[];
  categories: string[];
  excerpt: string;
  featured_image: string;
}

export default defineComponent({
  name: 'BlogShowcase',
  setup() {
    const posts = ref<Post[]>([]);
    const error = ref<Error | null>(null);

    const fetchPosts = async () => {
      try {
        const response = await fetch('/api/posts/');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        posts.value = data as Post[];
      } catch (err) {
        error.value = err as Error;
        console.error('Error fetching posts:', err);
      }
    };

    const formatDate = (dateString: string) => {
      const date = new Date(dateString);
      const correctedDate = new Date(date.getTime() + date.getTimezoneOffset() * 60_000);
      const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
      return correctedDate.toLocaleDateString(undefined, options);
    };

    const limitedPosts = computed(() => posts.value.slice(0, 6));

    onMounted(fetchPosts);

    return {
      error,
      formatDate,
      limitedPosts,
    };
  },
});
